<template>
  <div class="dropdown">
    <div
      :style="styles"
      class="dropdown-select"
      @click="active = !active"
      @mouseleave="mouseleave()"
      @mouseover="mouseover()"
    >
      <div class="container-label">
        <feather class="box-icon__left" type="map-pin" size="12px" />
        <span class="select-box">{{ selected.label }}</span>
      </div>
      <feather class="icon-feather" type="chevron-down" size="18px" />
    </div>
    <div :class="active ? 'enabled' : 'disabled'" class="dropdown-list" @click="active = !active">
      <div v-for="item of data" :key="item.id" class="dropdown-list__item" @click="select(item)">
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		data: {
			type: Array,
			required: true,
			default: () => [],
		},
		border: {
			type: String,
			required: false,
			default: '',
		},
		width: {
			type: String,
			required: true,
			defaul: '100%',
		},
		hoverColor: {
			type: String,
			default: '',
		},
		height: {
			type: String,
			required: true,
			default: '41px',
		},
	},
	data() {
		return {
			selected: this.data[0] ? this.data[0] : 'Selecione um item',
			borderColor: this.border,
			active: false,
		};
	},
	computed: {
		styles() {
			return {
				border: this.borderColor,
				width: this.width,
				height: this.height,
			};
		},
	},
	created() {
		this.$emit('selected', this.selected);
	},
	methods: {
		mouseover() {
			this.borderColor = this.hoverColor;
		},
		mouseleave() {
			this.borderColor = this.border;
		},
		select(item) {
			this.selected = item;
			this.$emit('selected', item);
		},
	},
};
</script>

<style scoped>
.box-icon__left {
	margin-right: 6px;
}
.container-label {
	display: flex;
	align-items: center;
}
.dropdown {
	position: relative;
}

.dropdown-select {
	padding: 10px;
	border-radius: 4px;
	background-color: white;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 12px;
	font-weight: bold;
	cursor: pointer;
	transition: 200ms ease-in-out;
}
.dropdown-list {
	border-radius: 4px;
	background-color: white;
	position: absolute;
	box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
	top: 110%;
	border-radius: 5px;
	left: 0;
	right: 0;
	opacity: 0;
	visibility: hidden;
	transition: opacity 0.3s linear, visibility 0.3s linear;
}
.enabled {
	opacity: 1;
	visibility: visible;
}
.disabled {
	opacity: 0;
	visibility: hidden;
}
.dropdown-list__item:hover {
	background-color: #e9f5db;
	color: #000;
}
.dropdown-list__item:first-child {
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
}
.dropdown-list__item:last-child {
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
}
.dropdown-list__item {
	cursor: pointer;
	transition: 300ms ease-in-out;
	padding: 1rem;
	font-size: 12px;
}
</style>
